export const labelIdSuffix = "-label";
export const nameIdSuffix = "-name";
